import { useCallback, useState } from "react";
import { getEligibility, isNotFound } from "../../api/client";
import type { Eligibility } from "../../api/types";

export type MissingWallet = "phantom" | "metamask" | null;

export interface AirdropFlow {
  /** The Solana address being checked, as typed or as returned by Phantom. */
  solanaAddress: string;
  setSolanaAddress: (value: string) => void;
  /** Set once a check succeeds. Null means step 1 is not done. */
  eligibility: Eligibility | null;
  setEligibility: (value: Eligibility | null) => void;
  /** Re-reads eligibility so a fresh registration shows up immediately. */
  refresh: () => Promise<void>;
  /** The EVM address MetaMask is currently offering. */
  evmAddress: string | null;
  setEvmAddress: (value: string | null) => void;
  missingWallet: MissingWallet;
  setMissingWallet: (value: MissingWallet) => void;
}

export function useAirdropFlow(): AirdropFlow {
  const [solanaAddress, setSolanaAddress] = useState("");
  const [eligibility, setEligibility] = useState<Eligibility | null>(null);
  const [evmAddress, setEvmAddress] = useState<string | null>(null);
  const [missingWallet, setMissingWallet] = useState<MissingWallet>(null);

  const refresh = useCallback(async () => {
    if (!eligibility) return;
    try {
      setEligibility(await getEligibility(eligibility.solanaAddress));
    } catch (error) {
      if (isNotFound(error)) setEligibility(null);
    }
  }, [eligibility]);

  return {
    solanaAddress,
    setSolanaAddress,
    eligibility,
    setEligibility,
    refresh,
    evmAddress,
    setEvmAddress,
    missingWallet,
    setMissingWallet,
  };
}
